import {OmniObject} from './';

export default class OmniPolygon extends OmniObject {
  className = 'Polygon';
  constructor(opts) {
    super();
    if (opts) {
      Object.keys(opts).forEach(i => {
        try {
          this[i] = opts[i];
          // eslint-disable-next-line
        } catch (e) {}
      });
    }
  }

  beforeRender() {
    this.height = this.calculateHeight();
  }
  calculateHeight() {
    if (this.sides % 2 === 0) {
      return this.width;
    }
    return (this.width / 2) * Math.cos(Math.PI / this.sides) + this.width / 2;
  }
  draw() {
    this.ctx
      .save()
      .beginPath()
      .translate(this.width / 2, this.width / 2)
      .moveTo(0, -this.width / 2);

    for (let i = 0, l = this.sides; i < l; ++i) {
      if (this.starMode) {
        this.ctx
          .rotate((180 / this.sides) * (Math.PI / 180))
          .lineTo(0, -this.width / 4)
          .rotate((-180 / this.sides) * (Math.PI / 180));
      }
      this.ctx
        .rotate((360 / this.sides) * (Math.PI / 180))
        .lineTo(0, -this.width / 2);
    }
    if (this.donutMode) {
      this.ctx.moveTo(0, (-this.width / 2) * this.donutSize);
      for (let i = 0, l = this.sides; i < l; ++i) {
        if (this.starMode) {
          this.ctx
            .rotate((-180 / this.sides) * (Math.PI / 180))
            .lineTo(0, (-this.width / 4) * this.donutSize)
            .rotate((180 / this.sides) * (Math.PI / 180));
        }
        this.ctx
          .rotate((-360 / this.sides) * (Math.PI / 180))
          .lineTo(0, (-this.width / 2) * this.donutSize);
      }
    }
    this.ctx.setFillStyle(this.color).fill().restore();
  }
  sides = 5;
  starMode = false;
  donutMode = false;
  donutSize = 0.5;
  changeSides(sides) {
    this.sides = sides;
    this.controller.render();
  }
}
